module.exports = __webpack_public_path__ + "static/img/img_zhijian.3e57f735.png";